var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgContacts = function SvgContacts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "contacts_svg__Light",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".contacts_svg__st0{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 22.5c0 .6-.4 1-1 1h-16V.5h16c.6 0 1 .4 1 1zM3.5.5h-2c-.6 0-1 .4-1 1v21c0 .6.4 1 1 1h2M20.5 2h1c1.1 0 2 .9 2 2v3h-3M20.5 7h3v5h-3M20.5 12h3v5h-3M20.5 17h3v3c0 1.1-.9 2-2 2h-1",
    className: "contacts_svg__st0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "contacts_svg___10_12.5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 17.5c0-2.8-2.2-5-5-5s-5 2.2-5 5z",
    className: "contacts_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 8,
    r: 3,
    className: "contacts_svg__st0"
  }))));
};
export default SvgContacts;